import { Trans } from '@lingui/macro'
import { AddHomeWorkOutlined, BroadcastOnPersonalOutlined, PendingActionsOutlined } from '@mui/icons-material'
import TouchRipple from '@mui/material/ButtonBase'
import { authRoles, isOnlyRole } from 'app/auth/authRoles'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import { checkOrganizationDetailsValidity } from 'app/services/sfAuth/sfData/sfAccount'
import { GRANTS_PATH } from 'app/views/grants/GrantsRoutes'
import { EgretVerticalNavExpansionPanel } from 'egret'
import { NavIcon } from 'egret/components/EgretVerticalNav/NavIcon'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { NavLink, useHistory } from 'react-router-dom'
import { usePendingJoinRequests } from './usePendingJoinRequests'

const OrganisationError = ({ title, href, icon }) => {
  if (!href) {
    return (
      <div className='nav-organisation-error-container'>
        <div className='nav-organisation-error '>
          <NavIcon item={{ icon }} />
          <div className='nav-item-text flex-middle' style={{ paddingLeft: 10, fontSize: 14, textAlign: 'left' }}>{title}</div>
        </div>
      </div>
    )
  }

  return (
    <div className='nav-organisation-error-container'>
      <NavLink to={href}>
        <TouchRipple className='w-100'>
          <div className='nav-organisation-error '>
            <NavIcon item={{ icon }} />
            <div className='nav-item-text flex-middle' style={{ paddingLeft: 10, fontSize: 14, textAlign: 'left' }}>{title}</div>
          </div>
        </TouchRipple>
      </NavLink>
    </div>
  )
}

export const OrganisationPanel = ({ user, organization, settings }) => {
  const [isInvalid, setIsInvalid] = useState(false)
  const [checked, setChecked] = useState(false)
  const history = useHistory()
  const simulateInternal = useSelector(
    state => state?.testingOptions?.simulateInternal
  )
  const isInternal = simulateInternal || sfOauthConfig.isInternal

  const location = useLocation()
  const pathname = location?.pathname

  useEffect(() => {
    if (organization && organization.id) {
      checkOrganizationDetailsValidity(organization.id, pathname).then(
        isValid => {
          setIsInvalid(!isValid)
          setChecked(true)
        }
      )
    }
  }, [organization])

  const { pendingJoinRequests = [] } = usePendingJoinRequests()

  const config = useSelector(state => state.configuration)
  const configOrganizationPageId = config?.FORM_ORGANIZATION_DETAILS

  // Check if the organization form page is different from the page in the portal configuration
  const isOrgFormIsDifferent =
    configOrganizationPageId &&
    configOrganizationPageId !== organization?.formPageId

  const showOrgFormIsDifferentWarning =
    isOrgFormIsDifferent && organization?.formPageId && isInvalid

  const isManager =
        user.organizationMember &&
        user.organizationMember.TeamMemberRole === 'Manager'

  if (isOnlyRole(user.role, authRoles.DMAH)) {
    return null
  }

  if ((organization && !organization?.organisationsName && pendingJoinRequests && !pendingJoinRequests.length) || !organization) {
    return (
      <OrganisationError
        href={GRANTS_PATH.JOIN_ORGANIZATION}
        title={<Trans>ORGANIZATION_PANEL_NO_ORGANIZATION_ERROR</Trans>}
        icon={<AddHomeWorkOutlined className='nav-item-icon' />}
      />
    )
  }

  if (organization && !organization?.organisationsName && pendingJoinRequests && pendingJoinRequests.length) {
    return (
      <OrganisationError
        href={GRANTS_PATH.JOIN_ORGANIZATION}
        title={<Trans>ORGANIZATION_PANEL_CONNECTION_REQUEST_PENDING_ERROR</Trans>}
        icon={<PendingActionsOutlined className='nav-item-icon' />}
      />
    )
  }

  if (checked &&
      !isInvalid &&
      user.staleOrganizations &&
      organization &&
      user.staleOrganizations.includes(organization.id)) {
    return (
      <OrganisationError
        href='/grants/organization-details'
        title={<Trans>ORGANIZATION_PANEL_STALE_ORGANIZATION_ERROR</Trans>}
        icon={<AddHomeWorkOutlined className='nav-item-icon' />}
      />
    )
  }

  if (showOrgFormIsDifferentWarning) {
    return (
      <OrganisationError
        href='/grants/organization-details'
        title={<Trans>ORGANIZATION_ICON_DIFFERENT_PORTAL_CONFIG_FORM_WARNING</Trans>}
        icon={<AddHomeWorkOutlined className='nav-item-icon' />}
      />
    )
  }

  return (
    <div className='navigation w-100 organization-panel'>
      <EgretVerticalNavExpansionPanel item={{
        name: organization?.organisationsName,
        icon: <BroadcastOnPersonalOutlined className='nav-item-icon' />
      }}
      >
        {isManager &&
          <NavLink to={GRANTS_PATH.MANAGE_MEMBERS} className='nav-item'>
            <TouchRipple
              className='nav-item flex-middle h-48 w-100'
            >
              <div className='flex' style={{ flexGrow: 1 }}>
                <div className='item-icon' />
                <span className='text-align-left nav-item-text' style={{ paddingLeft: 10 }}>
                <Trans>ORGANIZATION_PANEL_MANAGE_USERS</Trans>
              </span>
              </div>
            </TouchRipple>
          </NavLink>}
      </EgretVerticalNavExpansionPanel>
    </div>
  )
}
